import { CONFIG } from "~/route/globals";
import { ROUTE_CONST } from "~/route/const";
import { frpc } from "~/util/general";

const PLANNER_URL = "/tplanner";
const TRAFFIC_DATA = "/rainworm";

//const NUM_NEXT_LINE_LOAD = 4;

export function route(args) {
	args[1].alter = Mapy.CML.state.route.alternatives && args[0].length === 2 && !("routeWaypoints" in args[1]);

	if (ROUTE_CONST.types.pubt.criterion.indexOf(args[0][0]?.routeParams?.criterion || 0) > -1) {
		delete args[1].alter;
	}

	args[1].isPlanable = true;
	args[1].publicPlanable = true;

	const hints = {};

	if (args[1].maxSpeedLimit) {
		hints[`1.maxSpeedLimit`] = "float";
	}

	return frpc({
		url: CONFIG.requestUrl + PLANNER_URL,
		method: "alterRoute",
		args,
		hints,
	});
}

export function trafficData(routePartIds: Array<string>, datetime = "", maxSpeedEnabled = false) {
	const json = {
		parts: routePartIds.map(routePartId => ({
			// eslint-disable-next-line camelcase
			route_part_id: routePartId,
			// eslint-disable-next-line camelcase
			from_idx: 0,
			...Mapy.CUS.route.datetimeForAll && datetime ? { datetime } : {},
			// eslint-disable-next-line camelcase
			...Mapy.CUS.route.datetimeForAll || maxSpeedEnabled ? { get_time: true } : {},
			// eslint-disable-next-line camelcase
			...maxSpeedEnabled ? { get_max_speeds: true, get_length: true } : {},
		})),
	};

	return Mapy.Util.request(`${CONFIG.requestUrl}${TRAFFIC_DATA}/rainworm/v1/route/parts`, {
		method: "POST",
		json,
	});
}

export function routePTTripInfos(tripsIds: Array<string>) {
	return frpc({
		url: CONFIG.requestUrl + PLANNER_URL,
		method: "getTripInfos",
		args: [tripsIds],
	});
}

export function getNextDepartures(partDesc, indexes: Array<number>, flags) {
	//console.log(NUM_NEXT_LINE_LOAD);

	const args = [[]];

	indexes.forEach(index => {
		args[0].push([partDesc, {
			...flags,
			reqindex: index,
			tripData: true,
		}]);
	});

	return frpc({
		url: CONFIG.requestUrl + PLANNER_URL,
		method: "getNextDepartures",
		args,
	});
}
